import React, { useState } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import Text from "../../components/common/Text";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import {
  tenzero,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Q_SelectTrue(props) {
  const [questionRerender, setQuestionRerender] = useState(false);

  const question = props.question;
  const options = props.options;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const setSubmission = props.setSubmission;

  function onSelected(e) {
    const value = e.target.innerHTML;
    let submit = submission;
    let submit2 = [];
    if (submit[questionNumber] === undefined) submit2 = [];
    else submit2 = submit[questionNumber];
    if (submit2.length === 0) submit2.push(value);
    else {
      if (submit2.includes(value)) submit2.splice(submit2.indexOf(value), 1);
      else submit2.push(value);
    }
    submit[questionNumber] = submit2;
    setSubmission(submit);
    setQuestionRerender(!questionRerender);
  }

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      let formattedText = formatLatexText(options[i].text);

      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex", fontSize: "0.9rem" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",

                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {formattedText && <Latex>{formattedText}</Latex>}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function MultipleSelectButtons() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);
      const value = MakeButton(letter, options.length);
      arr.push(value);
    }
    return <Div padding={"0 10px"}>{arr}</Div>;
  }

  function MakeButton(text, numberOption) {
    const select = submission[questionNumber];
    let highlighted = false;
    if (select === undefined || select === null) highlighted = false;
    else highlighted = select.includes(text) ? true : false;

    const width = (window.innerWidth - numberOption * 2 * 3) / 2;
    const buttonWidth = width / numberOption;

    return (
      <Button
        key={"Button".concat(text)}
        onClick={onSelected}
        width={"60px"}
        height={"40px"}
        margin={"2px 3px"}
        backgroundColor={
          highlighted ? "rgba(16,44,79,0.4)" : "rgba(16,44,79,1)"
        }
        color={"#FFFFFF"}
        borderRadius={"5px"}
        fontWeight={"bold"}
      >
        {text}
      </Button>
    );
  }

  return (
    <Div height={"100%"} borderRadius={"1px"} width={"100%"}>
      <Div overflowY={"auto"} height={"80%"}>
        <QuestionText question={question} />
        <Image src={question.url} width="200px" />
        <Div margin={tenzero}>
          <Text>{Options()}</Text>
        </Div>
      </Div>
      <Div
        margin={fixMarginQuestionButtons(options.length)}
        bottom={"0"}
        position={"relative"}
      >
        {MultipleSelectButtons()}
      </Div>
    </Div>
  );
}
